import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalContatoModule } from '../_shared/modal-contato/modal-contato.module';
import { FooterComponent } from './footer.component';

@NgModule({
  declarations: [FooterComponent],
    imports: [
        CommonModule,
        RouterModule,
        ModalContatoModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule
    ],
    exports: [
        FooterComponent
    ]
})
export class FooterModule { }
